import { logger } from './logger.js';
import { platformBrandsRepo } from './repositories/earnings-repo.js';
import { hostnameToBrandRepo } from './repositories/indices-repo.js';
import type { PlatformBrand } from '@kilat/shared';

const BOOTSTRAP_BRAND_ID = 'kilat';

/**
 * Sprint 88 — agent-pwa brand resolver. Mirror of the marketing /
 * dashboard / customer-pwa resolver per ADR-0017. The brand seed in
 * `platformBrands/{brandId}.domains.agent` is the registered host for
 * each brand's agent-pwa; aliases pick up custom domains + dev URLs.
 */
export async function resolveBrandIdForHost(host: string): Promise<string> {
  const normalised = host.toLowerCase().split(':')[0] ?? host.toLowerCase();

  if (
    normalised === 'localhost' ||
    normalised.startsWith('127.0.0.1') ||
    normalised.endsWith('.local')
  ) {
    return BOOTSTRAP_BRAND_ID;
  }

  const indexed = await hostnameToBrandRepo.get(normalised);
  if (indexed) return indexed.platformBrandId;

  const brands = await platformBrandsRepo.list();
  for (const brand of brands) {
    const d = brand.domains;
    if (
      normalised === d.marketing ||
      normalised === d.dashboard ||
      normalised === d.agent ||
      normalised === d.find ||
      (d.aliases ?? []).includes(normalised)
    ) {
      return brand.id;
    }
  }

  logger.warn('brand-resolver: no brand matched host; using bootstrap', { host: normalised });
  return BOOTSTRAP_BRAND_ID;
}

export async function loadBrand(brandId: string): Promise<PlatformBrand> {
  const brand = await platformBrandsRepo.get(brandId);
  if (!brand) throw new Error(`platformBrands/${brandId} not found`);
  return brand;
}
